import { BranchConditionOperand } from '../../enums/branch-condition-operand';
import { BranchConditionOperator } from '../../enums/branch-condition-operator';

export class BuilderBranchConditionComponent {
  operand: BranchConditionOperand;
  operator: BranchConditionOperator;
  comparisonValue: string;

  constructor(
    operand: BranchConditionOperand,
    operator: BranchConditionOperator,
    comparisonValue: string,
  ) {
    this.operand = operand;
    this.operator = operator;
    this.comparisonValue = comparisonValue;
  }
}
